'use client';
import { Modal } from "antd";
import { forwardRef, useImperativeHandle, useState } from "react";
import ForgotPasswordForm from "./ForgotPasswordForm";

export interface ForgotPasswordModalRef {
  open: () => void;
  close: () => void;
}

type ForgotPasswordModalProps = {
  onSwitchToLogin?: () => void;
};

const ForgotPasswordModal = forwardRef<ForgotPasswordModalRef, ForgotPasswordModalProps>(
  ({ onSwitchToLogin }, ref) => {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
      setOpen(false);
    };

    const handleOpen = () => {
      setOpen(true);
    };

    useImperativeHandle(ref, () => {
      return {
        open: handleOpen,
        close: handleClose,
      };
    }, [handleClose, handleOpen]);

    return (
      <Modal
        open={open}
        footer={null}
        onCancel={handleClose}
        width={450}
        destroyOnHidden
        centered
      >
        <ForgotPasswordForm onClose={handleClose} />
      </Modal>
    );
  }
);

ForgotPasswordModal.displayName = 'ForgotPasswordModal';

export default ForgotPasswordModal;